import React from "react";
import { captureApi, createWaitlist } from "../../../../../crud/checkout.crud";
import PayByRazorPay from "./RazorPayButton";
import GetCurrency from "../../../../../helpers/services";
import { useEffect, useState, useContext } from "react";
import WidgetContext from "../../../../../contexts/WidgetContext";
import Router from "next/router";
import { CurrencyWithAmount, errorToaster } from "../../../../../helpers/utils";
import ReadMore from "../../../../../components/ReadMoreText";
import Ticket from "../CartBox/Settlements/calculations";
import moment from "moment";
import { getGroupDiscountDetails, isOnDiscount } from "../../../../../helpers/common";
const TicketSummary = ({
	selectedTickets,
	couponCode,
	// attendeesDetails,
	groupDiscounts,
	eventDetails,
	query,
	paymentMethod,
	isInternationalEvent,
	// reviewDetails,
	isMobile
	// consentsState,
	// setConsentsState
}) => {
	// const [utm, setUtm] = useState({});
	const [apiLoading, setApiLoading] = useState(false);
	// const widgetContext = useContext(WidgetContext);
	// const [isWaitlist, setIsWaitlist] = useState(false);

	// "api_key": "f279b2fe-f33e-461c-98a3-1672752e2c35",
	// "datetime_of_expiry": "2023-03-23T12:30:00"

	const isInternationalTicket =
		!_.isEmpty(selectedTickets) &&
		selectedTickets?.find(obj => obj.currency_name !== eventDetails.currency_name)
			? true
			: false; //domestic event where international ticket is selected

	//Tax and pg charges percentage and details
	const paymentMethodFee = isInternationalEvent
		? 0
		: paymentMethod
			? eventDetails[`${paymentMethod}_pg_percentage`]
			: eventDetails.cards_pg_percentage;
	const taxPercentage = eventDetails.tax_percentage; // 18
	const pgChargesPercentage = isInternationalEvent
		? eventDetails.non_inr_pg_percentage
		: isInternationalTicket
			? eventDetails.kh_percentage + eventDetails.non_inr_pg_percentage
			: eventDetails.kh_percentage + paymentMethodFee; // 4
	const isPgChargeInclusive = eventDetails.is_pg_charge_inclusive; // false
	const isTaxInclusive = eventDetails.is_tax_inclusive; // true
	const isTaxable = eventDetails.is_taxable; // false
	const taxName = eventDetails.tax_name;

	const taxPercentageOnPg = eventDetails.tax_percentage_on_pg; // 18
	const isTaxOnPgInclusive = eventDetails.is_tax_on_pg_inclusive;
	const basePgPercentage =
		eventDetails.non_inr_pg_percentage / (1 + eventDetails.tax_percentage_on_pg / 100);
	// const [errors, seterrors] = useState([])

	// const [consentsState, setConsentsState] = useState(eventDetails.consents)
	// const [consentsBE, setConsentsBE] = useState({}) // consents data that need to be sent to the BE
	let pvt_discount = selectedTickets.map(
		ticket => ticket.discounted_price && ticket.discounted_price * ticket.totalSelected
	);
	pvt_discount = pvt_discount.reduce((prev, curr) => prev + curr, 0) || 0;

	//for group ticket discount
	const isOnSale = selectedTickets.some(({ automatic_discount_rules }) =>
		isOnDiscount(automatic_discount_rules)
	);

	const currency = selectedTickets?.find(obj => obj.currency_name !== eventDetails.currency_name)
		? selectedTickets?.find(obj => obj.currency_name !== eventDetails.currency_name)
				.currency_name
		: eventDetails.currency_name;

	const group_discount = getGroupDiscountDetails(
		groupDiscounts,
		selectedTickets,
		couponCode
	).maxDiscount;

	let originalPrice = 0;
	selectedTickets.map(
		ticket => (originalPrice = originalPrice + ticket.ticket_price * ticket.totalSelected)
	); // Calculating all the tickets price
	const ticket = new Ticket(
		originalPrice,
		isTaxable,
		!isTaxInclusive,
		taxPercentage,
		!isPgChargeInclusive,
		pgChargesPercentage,
		pvt_discount,
		group_discount,
		isTaxOnPgInclusive,
		taxPercentageOnPg,
		basePgPercentage
	);
	const ticketPriceDetails = ticket.calculate();

	//Waitlist useEffect - Check if waitlist ticket
	// useEffect(() => {
	//   if (selectedTickets.length === 1) {
	//     let isWaitlist = false;
	//     selectedTickets.forEach(ticket => {
	//       if (ticket.waitlist_enabled && ticket.sold_out ||
	//         ticket.remaining_count <= 0 && ticket.waitlist_enabled) {
	//         ticket.waitlist_done ? isWaitlist = false : isWaitlist = true;
	//       }
	//     })
	//     if (isWaitlist) setIsWaitlist(true);
	//   }
	// }, [])

	// useEffect(() => {
	//   const utm = {
	//     ...(query.utm_source && { utm_source: query.utm_source }),
	//     ...(query.utm_medium && { utm_medium: query.utm_medium }),
	//     ...(query.utm_campaign && { utm_campaign: query.utm_campaign }),
	//   };

	//   setUtm(utm);
	// }, [query]);

	// const storeAndredirect = (data, eventDet) => {
	//   sessionStorage.setItem("data", data);
	//   sessionStorage.setItem("eventDetails", eventDet);
	//   if (widgetContext.isWidget)
	//     Router.push({
	//       pathname: `/widget/ticket-confirmation`,
	//       query: query,
	//     });
	//   else Router.push({ pathname: `/checkout/ticket-confirmation` });
	// }

	// const freeRegistration = async () => {
	//   const payload = {
	//     event_id: eventDetails.event_id,
	//     ...(widgetContext.couponCode && { coupon_code: widgetContext.couponCode }),
	//     ...(widgetContext.otp && { otp: widgetContext.otp }),
	//     utm: utm,
	//     registration_details: attendeesDetails,
	//     consents: consentsBE
	//   };
	//   setApiLoading(true);
	//   try {
	//     const res = await captureApi(payload);
	//     const data = JSON.stringify(res.data);
	//     const eventDet = JSON.stringify(eventDetails);
	//     storeAndredirect(data, eventDet)
	//   } catch (err) {
	//     console.log(err);
	//     const error = err.response.data.error || "Something went wrong";
	//     errorToaster(error);
	//     setApiLoading(false);
	//   }
	// };

	// consents error check
	// const consentsErrorCheck = (consentsState) => {
	//   let errorsarr = [];
	//   for (let i = 0; i < consentsState.length; i++) {
	//     if (
	//       !consentsState[i].is_checked && consentsState[i].is_mandatory
	//     ) {
	//       if (errorsarr[i] === undefined) errorsarr[i] = {};
	//       errorsarr[i].consenterr = `${consentsState[i].consent_name.replace(/_/, " ").replace(/(^\w|\s\w)/, m => m.toUpperCase())} is mandatory`;
	//     }
	//   }
	//   seterrors(errorsarr)
	// }

	// create consents BE data
	// const createConstentsBEdata = (consentsState) => {
	//   let consentObj = { other_consents: {} }
	// consentsState.forEach((consent, i) => {
	//   if (consent.consent_name === "KonfHub Subscription") consentObj.is_subscriber  = consent.is_checked;
	//   if (consent.consent_name === "Consent To Organiser") consentObj.consent_to_organiser = consent.is_checked;
	//   else if (consent.consent_id && (consent.consent_name !== "KonfHub Subscription" || consent.consent_name !== "KonfHub Subscription")) consentObj.other_consents = { ...consentObj.other_consents, [consent.consent_id]: consent.is_checked };
	//   consentObj.konfhub_consent = true;
	// })
	//   setConsentsBE(consentObj);
	// }

	// useEffect(() => {
	//   consentsErrorCheck(consentsState);
	//   createConstentsBEdata(consentsState);
	// }, [consentsState])

	//Consents Element
	// const getconsents = () => {
	//   let newConsents = [...consentsState]
	//   return consentsState.map((consentsitem, index) => (
	//     <div className="mb-3 " key={index} >
	//       <div className="d-flex">
	//         <input
	//           type="checkbox"
	//           className="me-2"
	//           id={isMobile ? `${consentsitem.consent_name}-mobile` : `${consentsitem.consent_name}`}
	//           name="consent"
	//           onChange={() => {
	//             newConsents[index] = { ...consentsitem, is_checked: !consentsitem.is_checked }
	//             setConsentsState(newConsents);
	//           }}
	//           checked={consentsitem.is_checked}
	//         />
	//         <label
	//           htmlFor={isMobile ? `${consentsitem.consent_name}-mobile` : `${consentsitem.consent_name}`}
	//           style={{ fontSize: "14px" }}
	//         >
	//         </label>
	//         <div style={{ fontSize: "14px" }}>
	//           <ReadMore
	//             lines={2}
	//             content={consentsitem.consent_text.replace(/(<p[^>]+?>|<p>|<\/p>)/img, "")}
	//           />
	//         </div>
	//       </div>
	//       {!consentsitem.is_checked && consentsitem.is_mandatory && (
	//         <span className="error-text mt-0 mb-2 ms-0" >
	//           Please read &amp; accept the mandatory   {consentsitem.consent_name.replace(/_/, " ").replace(/(^\w|\s\w)/, m => m.toUpperCase())}
	//         </span>
	//       )}
	//     </div>

	//   ))
	// }

	// const waitlistRegistration = async () => {
	//   const ticketId = Object.keys(attendeesDetails)[0]
	//   const payload = {
	//     payment_mode: ticketPriceDetails.rounded > 0 ? 1 : 0,
	//     ticket_id: ticketId,
	//     consents: consentsBE,
	//     waitlist_details: attendeesDetails[ticketId][0]
	//   };
	//   setApiLoading(true);
	//   try {
	//     const res = await createWaitlist(payload, eventDetails.event_id);
	//     const data = JSON.stringify({ waitlist: true, message: res.data.message });
	//     const eventDet = JSON.stringify(eventDetails);
	//     storeAndredirect(data, eventDet)
	//   } catch (err) {
	//     console.log(err);
	//     const error = err.response.data || "Something went wrong";
	//     errorToaster(error);
	//     setApiLoading(false);
	//   }
	// };

	// const buttonType = (totalAmount) => {
	//   if (isWaitlist) {
	//     return (
	//       <button
	//         className="w-100 p-2 btn register-btn mb-2"
	//         onClick={waitlistRegistration}
	//         disabled={errors.length}
	//       >
	//         Join Waitlist
	//       </button>
	//     )
	//   } else if (totalAmount === 0) {
	//     return (
	//       <button
	//         className="w-100 p-2 btn register-btn mb-2"
	//         onClick={freeRegistration}
	//         disabled={errors.length}
	//       >
	//         Register
	//       </button>
	//     )
	//   } else {
	//     return (
	//       <PayByRazorPay
	//         eventDetails={eventDetails}
	//         orderAmount={totalAmount}
	//         attendeesDetails={attendeesDetails}
	//         utm={utm}
	//         reviewDetails={reviewDetails}
	//         query={query}
	//         btnDisabled={errors.length}
	//         isWidget={widgetContext.isWidget}
	//         couponCode={widgetContext.couponCode}
	//         setApiLoading={setApiLoading}
	//         consents={consentsBE}
	//       />
	//     )
	//   }
	// }
	const getFinalPrice = () => {
		if (paymentMethod || isInternationalEvent || isPgChargeInclusive)
			return ticketPriceDetails.rounded;
		else if (isTaxable && !isTaxInclusive && !isPgChargeInclusive)
			return `${
				parseFloat(ticketPriceDetails.subTotal.toFixed(2)) +
				parseFloat(ticketPriceDetails.taxAmount.toFixed(2))
			}*`;
		else if (isTaxInclusive && !isPgChargeInclusive)
			return `${parseFloat(ticketPriceDetails.subTotal.toFixed(2))}*`;
		else if (isTaxInclusive && isPgChargeInclusive) return ticketPriceDetails.rounded;
		else if (!isTaxInclusive && !isPgChargeInclusive)
			return `${
				parseFloat(ticketPriceDetails.subTotal.toFixed(2)) +
				parseFloat(ticketPriceDetails.taxAmount.toFixed(2))
			}*`;
		else return ticketPriceDetails.rounded;
	};

	return (
		<>
			<div className="summary-container row px-3 mb-2 ms-1 me-1">
				<div className="summary-header col-12 d-flex flex-column justify-content-start align-items-start p-0">
					<h3 className="mt-4 d-md-flex d-none">Ticket Summary</h3>
					{selectedTickets.map((i, index) => (
						<div
							key={index}
							className="price-summary mt-1 w-100 d-flex flex-wrap justify-content-between align-items-center"
						>
							<h5 className="m-0 ">{i.ticket_name}</h5>
							<div className="quant ">x {i.totalSelected}</div>
							{originalPrice !== 0 && (
								<div className="price">
									<CurrencyWithAmount
										fontSize="12px"
										currencyName={i.currency_name}
										number={i.ticket_price.toFixed(2)}
									/>
								</div>
							)}
						</div>
					))}
					{ticketPriceDetails.discount !== 0 && (
						<div className="price-summary mt-1 w-100 d-flex flex-wrap justify-content-between align-items-center">
							<span
								className="quant d-flex justify-content-start"
								style={{ color: "#41C34A" }}
							>
								Discount
							</span>
							<span className="price" style={{ color: "#41C34A" }}>
								-{" "}
								<CurrencyWithAmount
									fontSize="12px"
									currencyName={currency}
									number={ticketPriceDetails.discount}
								/>
							</span>
						</div>
					)}
					{ticketPriceDetails.discount == 0 && ticketPriceDetails.groupDiscount !== 0 && (
						<div className="price-summary mt-1 w-100 d-flex flex-wrap justify-content-between align-items-center">
							<span
								className="quant d-flex justify-content-start"
								style={{ color: "#41C34A" }}
							>
								Discount
							</span>
							<span className="price" style={{ color: "#41C34A" }}>
								-{" "}
								<CurrencyWithAmount
									fontSize="12px"
									currencyName={currency}
									number={ticketPriceDetails.groupDiscount}
								/>
							</span>
						</div>
					)}
					{ticketPriceDetails.subTotal !== 0 && (
						<div className="price-summary mt-1 w-100 d-flex flex-wrap justify-content-between align-items-center">
							<span className="quant d-flex justify-content-start">Sub Total</span>
							<span className="price">
								<CurrencyWithAmount
									fontSize="12px"
									currencyName={currency}
									number={ticketPriceDetails.subTotal}
								/>
							</span>
						</div>
					)}

					{!isPgChargeInclusive && !isTaxInclusive && <hr className="my-2" />}
					{ticketPriceDetails.payableAmount !== 0 && originalPrice !== 0 && (
						<>
							{ticketPriceDetails.basePrice !== 0 &&
								!isPgChargeInclusive &&
								!isTaxInclusive && (
									<div className="price-summary mt-1 w-100 d-flex flex-wrap justify-content-between align-items-center">
										<span className="quant d-flex justify-content-start">
											Base Price
										</span>
										<span className="price">
											<CurrencyWithAmount
												fontSize="12px"
												currencyName={currency}
												number={ticketPriceDetails.basePrice}
											/>
										</span>
									</div>
								)}

							{isTaxable && !isPgChargeInclusive && !isTaxInclusive ? (
								<div className="price-summary mt-1 w-100 d-flex flex-wrap justify-content-between align-items-center">
									<span className="quant d-flex justify-content-start">{`${taxName} (${
										isTaxInclusive ? "Inclusive" : "Exclusive"
									})`}</span>
									<span className="price">
										<CurrencyWithAmount
											fontSize="12px"
											currencyName={currency}
											number={ticketPriceDetails.taxAmount}
										/>
									</span>
								</div>
							) : (
								isTaxable &&
								isPgChargeInclusive &&
								!isTaxInclusive && (
									<div className="price-summary mt-1 w-100 d-flex flex-wrap justify-content-between align-items-center">
										<span className="quant d-flex justify-content-start">{`${taxName} (${
											isTaxInclusive ? "Inclusive" : "Exclusive"
										})`}</span>
										<span className="price">
											<CurrencyWithAmount
												fontSize="12px"
												currencyName={currency}
												number={
													Number(ticketPriceDetails.taxAmount) +
													Number(ticketPriceDetails.taxOnPgCharges)
												}
											/>
										</span>
									</div>
								)
							)}

							{(paymentMethod || isPgChargeInclusive || isInternationalEvent) &&
							ticketPriceDetails.khFee > 0 &&
							!isPgChargeInclusive &&
							!isTaxInclusive ? (
								<div className="price-summary mt-1 w-100 d-flex flex-wrap justify-content-between align-items-center">
									<span
										style={{ whiteSpace: "pre-line" }}
										className="quant d-flex justify-content-start"
									>
										{` ${
											!isInternationalEvent
												? "Processing Fee"
												: "Payment Gateway \n Charges"
										}${isInternationalEvent ? " " : "\n"}(${
											isPgChargeInclusive ? "Inclusive" : "Exclusive"
										})`}
									</span>
									<span className="price">
										<CurrencyWithAmount
											fontSize="12px"
											currencyName={currency}
											number={ticketPriceDetails.khFee}
										/>
									</span>
								</div>
							) : (
								(paymentMethod || isPgChargeInclusive || isInternationalEvent) &&
								ticketPriceDetails.khFee > 0 &&
								!isPgChargeInclusive &&
								isTaxInclusive && (
									<div className="price-summary mt-1 w-100 d-flex flex-wrap justify-content-between align-items-center">
										<span
											style={{ whiteSpace: "pre-line" }}
											className="quant d-flex justify-content-start"
										>
											{` ${
												!isInternationalEvent
													? "Processing Fee"
													: "Payment Gateway \n Charges"
											}${isInternationalEvent ? " " : "\n"}(${
												isPgChargeInclusive ? "Inclusive" : "Exclusive"
											})`}
										</span>
										<span className="price">
											<CurrencyWithAmount
												fontSize="12px"
												currencyName={currency}
												number={
													Number(ticketPriceDetails.pgCharges) +
													Number(ticketPriceDetails.taxOnPgCharges)
												}
											/>
										</span>
									</div>
								)
							)}
						</>
					)}

					{ticketPriceDetails.payableAmount !== 0 && originalPrice !== 0 && (
						<hr className="my-2" />
					)}
				</div>
				<div className="summary-total col-12 d-flex flex-column justify-content-around align-items-start p-0 ">
					<div className="summary-total w-100 d-flex flex-wrap justify-content-between align-items-center mb-2">
						<h5 className="mb-0">Total</h5>
						<span className="text-end">
							<p className="mb-0">
								{originalPrice !== 0 ? (
									<>
										<CurrencyWithAmount
											fontSize="18px"
											currencyName={currency}
											number={getFinalPrice()}
										/>
									</>
								) : (
									"FREE"
								)}
							</p>
						</span>
					</div>
					{!isMobile &&
						!paymentMethod &&
						!isInternationalEvent &&
						originalPrice !== 0 && <hr className="m-0 mb-3" />}
					{!isPgChargeInclusive &&
						!isInternationalEvent &&
						!paymentMethod &&
						originalPrice !== 0 &&
						ticketPriceDetails.khFee > 0 && (
							<p
								style={{ color: "#fa6d0f", fontSize: "12px" }}
								className="text-center"
							>
								Processing Fee will be added on selecting payment method*
							</p>
						)}
					{/* Consents Element */}
					{/* {getconsents()}
          <div className="mb-3"style={{ fontSize: "14px" }}>
          <ReadMore
              charLimit={50}
              lines={2}
              content={`By registering, I accept the KonfHub Terms & Conditions and Code Of Conduct and have read the Privacy Policy. I agree to KonfHub to share my information with the event organizer.`}/>
          </div> */}
					{/* {buttonType(parseFloat(ticketPriceDetails.rounded))} */}
				</div>
			</div>
			{/* {apiLoading && (
        <div className="checkout-overlay">
          <p className="checkout-overlay-text m-0">Please Wait</p>
          <div className="spinner-border ms-2"></div>
        </div>
      )} */}
			<style jsx global>
				{`
					.small-text {
						font-size: 12px !important;
					}
					.open {
						// display: inline-block;
						cursor: pointer;
						color: red;
					}

					.summary-container {
						width: 100%;
						background: ${query.primaryBg ? `#${query.primaryBg}` : "#FFF"};
						color: ${query.primaryCl ? `#${query.primaryCl}` : "#212529"};
						// box-shadow: inset 0px 0px 15px rgba(0, 0, 0, 0.15);
						border-radius: 15px;
						height: auto;
						position: sticky;
						top: 15px;
						width: 100%;
					}
					.error-text {
						margin-left: 5px;
						font-size: 11.5px !important;
						color: ${query.inputErrCl ? `#${query.inputErrCl}` : "red"};
					}
					.summary-header h3 {
						color: ${query.primaryCl ? `#${query.primaryCl}` : "#212529"};
						font-size: 20px;
					}
					.price-summary h5,
					.quant {
						word-break: break-word;
						font-size: 14px;
						color: ${query.primaryCl ? `#${query.primaryCl}` : "#212529"}8c;
					}
					.price {
						color: ${query.primaryCl ? `#${query.primaryCl}` : "#212529"};
						font-size: 14px;
					}
					.summary-container hr {
						border: 1px solid #cccccc;
						width: 100%;
					}
					.summary-total span {
						font-size: 22px;
					}

					.register-btn {
						color: ${query.btnCl ? `#${query.btnCl}` : "#ffffff"};
						background: ${query.btnBg ? `#${query.btnBg}` : "#fb5850"};
					}

					.register-btn:hover {
						color: ${query.btnCl ? `#${query.btnCl}` : "#ffffff"};
					}
					input[type="checkbox"]:checked + label:before {
						background: ${query.btnBg ? `#${query.btnBg} !important` : "#FB5850"};
						color: ${query.btnCl ? `#${query.btnCl} !important` : "#ffffff"};
						border: 1px solid ${query.btnBg ? `#${query.btnBg} !important` : "#FB5850"};
					}

					@media (max-width: 768px) {
						.quant,
						.price-summary h5 {
							color: ${query.primaryCl ? `#${query.primaryCl}` : "black"};
						}
						.summary-container hr {
							border: none;
						}
					}
				`}
			</style>
		</>
	);
};

export default TicketSummary;
